// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1__a78b3da21489419d64be","cls2":"Header-cls2__e17ea32ea636f5108b27 Header-cls1__a78b3da21489419d64be"};